import { FormEvent, useCallback, useState } from 'react';
import { useAuthConfirmSignUp } from 'v2/core/clients/authAmplify/hooks';
import { QueryStatus } from 'v2/core/repository/edge-server/types';
import { RegisterState } from 'v2/views/layouts/authenticationModule/authTypes';
import { AuthError, toAuthError } from 'v2/core/services/auth/errors';

interface ConfirmSignUpInput {
  userPayload: RegisterState;
  code: string;
  onSuccess: (e: FormEvent) => Promise<void>;
  onError: (err: AuthError) => void;
}

const useConfirmSignUp = ({
  userPayload,
  code,
  onSuccess,
  onError,
}: ConfirmSignUpInput): [(e: FormEvent) => Promise<void>, QueryStatus] => {
  const { email } = userPayload;
  const [status, setStatus] = useState(QueryStatus.NOT_CALLED);
  const amplifyConfirmSignUp = useAuthConfirmSignUp();

  const confirmSignUp = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      setStatus(QueryStatus.IN_PROGRESS);
      try {
        await amplifyConfirmSignUp({ email, code });
        onSuccess(event);
        setStatus(QueryStatus.SUCCESS_COMPLETED);
      } catch (err: unknown) {
        onError(toAuthError(err));
        setStatus(QueryStatus.ERROR_COMPLETED);
      }
    },
    [amplifyConfirmSignUp, email, code, onSuccess, onError],
  );
  return [confirmSignUp, status];
};
export default useConfirmSignUp;
